import { NgComponentOutlet } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from '@webapp/core/services/event.service';
import { RiskRegistry } from '@webapp/risk-core';
import { ButtonComponent, ToastService } from '@webapp/ui';
import { QuoterInsurableTypes } from '../../../interfaces/quoter.interface';
import { QuoterInsurableService } from '../../../services/quoter-insurable.service';
import { QuoterStoreService } from '../../../store/quoter-store.service';
import { riskSidebarMap } from '../../../store/risks-sidebar-components.map';
import { UserResumeComponent } from '@webapp/core/ui/components/user-resume/user-resume.component';
import { ShowForChannelDirective } from '@webapp/core/directives/showForChannel';
import { ICoverage, PAYMENT_GATEWAYS } from '@webapp/payments';
import { QuoterSidebarCoverageComponent } from '../quoter-sidebar-coverage/quoter-sidebar-coverage.component';
import { InputReferralCodeComponent } from '@webapp/core/ui/components/input-referral-code/input-referral-code.component'

@Component({
  selector: 'app-quoter-sidebar',
  imports: [
    ButtonComponent,
    UserResumeComponent,
    QuoterSidebarCoverageComponent,
    InputReferralCodeComponent,
    NgComponentOutlet,
    ShowForChannelDirective
  ],
  standalone: true,
  templateUrl: './quoter-sidebar.component.html',
  styleUrl: './quoter-sidebar.component.scss',
})
export class QuoterSidebarComponent {
  private router = inject(Router);
  private toastService = inject(ToastService);
  private eventService = inject(EventService);
  private quoterInsurableService = inject(QuoterInsurableService);
  private riskRegistry = inject(RiskRegistry);
  readonly quoterStateService = inject(QuoterStoreService);
  additionalCoverage = signal<ICoverage[]>([]);
  readonly quoterState = this.quoterStateService.state.asReadonly();

  isVehicle() {
    return this.riskRegistry.find(this.quoterState().risk.tag)?.capabilities.vehicle ?? false;
  }

  setReferralCode(referralCode: string) {
    this.quoterStateService.set('code', referralCode);
  }

  hasOptionalCoverages() {
    const additionalCoverage = this.quoterState().quote.additionalCoverage;

    if (additionalCoverage && additionalCoverage.select) {
      return true;
    } else {
      return false;
    }
  }
  dynamicRiskComponent() {
    const riskType = this.quoterState().risk.tag;
    const riskMap = riskSidebarMap[riskType];
    if (riskMap) {
      const component = riskMap;
      if (!component) {
        console.error('Component not found:', riskType);
      }
      return component;
    }

    return null;
  }

  async emit() {
    if (this.quoterState().payment.exist) {
      if (
        !this.quoterState().payment.id

      ) {
        this.eventService.emit('payment_form_validation');
        this.toastService.showToast(
          'Ocurrió un error',
          'Debe seleccionar un medio de pago',
          'error',
          true
        );
        return;
      }
      if (this.quoterState().risk.paymentMethods.includes(PAYMENT_GATEWAYS.MERCADO_PAGO) && !this.quoterState().payment.securityNumber) {
        this.eventService.emit('payment_form_validation');
        this.toastService.showToast(
          'Ocurrió un error',
          'Debe agregar el código de seguridad',
          'error',
          true
        );
        return;
      }
    } else {

      if (!this.quoterState().payment.number) {
       
        this.eventService.emit('payment_form_validation');
        return;
      }
    }

    try {
      const insurable = this.quoterInsurableService.buildCustomInsurableData(
        this.quoterState().risk.tag
      );

      const policy = this.quoterStateService.buildPolicy<QuoterInsurableTypes>(
        insurable as Partial<QuoterInsurableTypes>
      );

      const success = await this.quoterStateService.emit(policy);
      if (success) {

        this.quoterStateService.set('hasUnsavedChanges', false);
        this.router.navigateByUrl('/cotizar/emision-exitosa');

      }
    } catch (error) {
      console.error('Error al emitir la cotización:', error);
    } finally {
      this.quoterInsurableService.clear(this.quoterState().risk.tag);
    }
  }

  async generatePaymentLink() {
    try {
      const insurable = this.quoterInsurableService.buildCustomInsurableData(
        this.quoterState().risk.tag
      );
      const policy = this.quoterStateService.buildPolicy<QuoterInsurableTypes>(
        insurable as Partial<QuoterInsurableTypes>
      );

      const paymentLink = await this.quoterStateService.generatePaymentLink(
        policy
      );
      if (paymentLink) {
        this.quoterStateService.set('hasUnsavedChanges', false);
        this.router.navigateByUrl('/cotizar/link-generado');
      }
    } catch (error) {
      console.error('Error al generar el link de pago:', error);
    }
  }
}
